import { useState } from "react";
import { CheckCircle2, Loader2, PhoneCall } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function CallbackCapture({ leadId }) {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post(`/leads/${leadId}/contact`, { phone, name: name.trim() || undefined });
      setSaved(data.contact_phone);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (saved) {
    return (
      <div className="mb-6 flex items-center gap-3 border border-emerald-500/30 bg-emerald-500/[0.06] rounded-sm px-4 py-3" data-testid="callback-saved">
        <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
        <p className="text-xs text-zinc-300">
          Got it — a senior broker will call <span className="text-emerald-400 font-mono-d">{saved}</span> shortly. You can still lock a time below.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mb-6 border border-amber-500/25 bg-amber-500/[0.05] rounded-sm p-4" data-testid="callback-form">
      <div className="flex items-center gap-2 mb-3">
        <PhoneCall className="w-4 h-4 text-amber-400" />
        <p className="text-xs font-mono-d tracking-[0.15em] uppercase text-amber-400">Prefer a call? A broker dials you within minutes</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          data-testid="callback-name-input"
          className="sm:w-40 bg-[#07090D] border border-white/15 rounded-sm px-3 py-2.5 text-sm text-zinc-100 placeholder:text-zinc-600 focus:outline-none focus:border-amber-500/60 transition-colors"
        />
        <input
          type="tel"
          required
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="(555) 123-4567"
          data-testid="callback-phone-input"
          className="flex-1 bg-[#07090D] border border-white/15 rounded-sm px-3 py-2.5 text-sm text-zinc-100 placeholder:text-zinc-600 focus:outline-none focus:border-amber-500/60 transition-colors"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="callback-submit-button"
          className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-40 text-[#07090D] font-semibold text-sm px-5 py-2.5 rounded-sm transition-all duration-300 active:scale-[0.98]"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <PhoneCall className="w-4 h-4" />}
          Call me
        </button>
      </div>
    </form>
  );
}
